import React from 'react';
import {
  TableQuery, OwnerIdFragment, TableDownstreamOwnerIdsFilteredByColumnQueryVariables, TableDownstreamOwnerIdsFilteredByColumnQuery, TableDownstreamOwnerIdsQueryVariables, TableDownstreamOwnerIdsQuery,
  TableDownstreamOwnerIdsFilteredByColumnDocument,
  TableDownstreamOwnerIdsDocument
} from '../../../../../gen-src/queries';
import {
  ComposeEmailPaneButton,
  DataCatalogApolloClient,
  getAllFromSliceable,
  GraphQLSliceable,
  MultiSelectionProvider,
  PaneTitle,
  Sliceable,
  VerticalFlexContainer,
} from '../../../data-catalog-shared';

import { OwnersGridSortProvider } from '../sorting/sortProviders/OwnersGridSortProvider';
import { MultiSelectionControls } from '../widgets/MultiSelectionControls';
import { TableDownstreamOwnersQueryGrid } from './TableDownstreamOwnersQueryGrid';

export interface TableDownstreamOwnersPaneProps {
  readonly title: string;
  // You can get the luid from this
  readonly table: Unpacked<TableQuery['tables']>;
  readonly tableId: string;
  readonly filteredColumnId: string | null;
  readonly rowCount: number | null;
}

export class TableDownstreamOwnersPane extends React.Component<TableDownstreamOwnersPaneProps> {

  public override render(): JSX.Element {
    return (
      <MultiSelectionProvider selectionId={this.props.tableId}>
        {({ selectedKeys, setSelectedKeys, updateSelectionForKey }) =>
          <VerticalFlexContainer fillFlexParent={true}>
            <PaneTitle>
              {this.props.title}
              {this.props.rowCount != null && this.props.rowCount > 0 ?
                <>
                  <MultiSelectionControls
                    selectedKeys={selectedKeys}
                    setSelectedKeys={setSelectedKeys}
                    updateSelectionForKey={updateSelectionForKey}
                    fetchAllKeys={this.fetchAllOwnerKeys}
                  />
                  <ComposeEmailPaneButton
                    selectedUserIds={selectedKeys}
                    contentType='table'
                    contentId={this.props.table.__typename === 'DatabaseTable'
                      ? this.props.table.vizportalId
                      : 'This is not a DatabaseTable, should never encounter this; vizportalId is only available on DatabaseTable'}
                    contentLuid={this.props.table.__typename === 'DatabaseTable'
                      ? this.props.table.luid
                      : 'This is not a DatabaseTable, should never encounter this; vizportalId is only available on DatabaseTable'}
                  />
                </>
                : null
              }
            </PaneTitle>
            <OwnersGridSortProvider>
              {({ orderBy, updateSortOrder }) =>
                <TableDownstreamOwnersQueryGrid
                  tableId={this.props.tableId}
                  selectedKeys={selectedKeys}
                  updateSelectionForKey={updateSelectionForKey}
                  filteredColumnId={this.props.filteredColumnId}
                  rowCount={this.props.rowCount}
                  orderBy={orderBy}
                  updateSortOrder={updateSortOrder}
                />
              }
            </OwnersGridSortProvider>
          </VerticalFlexContainer>
        }
      </MultiSelectionProvider>
    );
  }

  private readonly fetchAllOwnerKeys = async (client: DataCatalogApolloClient): Promise<ReadonlyArray<string>> => {
    const sliceable = this.createOwnerIdsSliceable(client);
    const items = await getAllFromSliceable(sliceable);
    return items.map(item => item.vizportalId);
  }

  private createOwnerIdsSliceable(client: DataCatalogApolloClient): Sliceable<OwnerIdFragment> {
    if (this.props.filteredColumnId) {
      return new GraphQLSliceable<
        OwnerIdFragment,
        OwnerIdFragment,
        TableDownstreamOwnerIdsFilteredByColumnQueryVariables,
        TableDownstreamOwnerIdsFilteredByColumnQuery
      >({
        queryGql: TableDownstreamOwnerIdsFilteredByColumnDocument,
        selectConnectionListResult: (resultData) => {
          const column = resultData.columns && resultData.columns[0];
          return column.downstreamOwnersConnection;
        },
        mapResultNode: (node) => node,
      }, { columnId: this.props.filteredColumnId }, client);
    } else {
      return new GraphQLSliceable<
        OwnerIdFragment,
        OwnerIdFragment,
        TableDownstreamOwnerIdsQueryVariables,
        TableDownstreamOwnerIdsQuery
      >({
        queryGql: TableDownstreamOwnerIdsDocument,
        selectConnectionListResult: (resultData) => {
          const table = resultData.tables && resultData.tables[0];
          return table.downstreamOwnersConnection;
        },
        mapResultNode: (node) => node,
      }, { tableId: this.props.tableId }, client);
    }
  }

}
